import React, { useState } from "react";

import axios from "../../helpers/axios";

import FieldEditorProvider from "./FieldEditorProvider";

const MultiPartFieldUpdate = (props) => {
  const { label, type, selection, field, onChange } = props;

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleSave = (event) => {
    event.preventDefault();
    setLoading(true);
    setSuccess("");

    let requests = 0;
    selection.forEach((partId) => {
      axios
        .patch(`/api/parts/${partId}/`, {
          [field]: value,
        })
        .then((response) => {})
        .catch((error) => {})
        .then(() => {
          requests += 1;
          if (requests === selection.length) {
            setLoading(false);
            setValue("");
            setSuccess("Datos guardados correctamente");
            onChange();
          }
        });
    });
  };

  return (
    <div className="field">
      <label htmlFor="" className="label">
        {label}
      </label>
      <div className="field is-fullwidth has-addons">
        <div className="control" style={{ flexGrow: 1 }}>
          <FieldEditorProvider type={type} value={value} setValue={setValue} />
          {success ? <div className="help is-success">{success}</div> : null}
        </div>
        <div className="control">
          <div
            className={"button is-primary" + (loading ? " is-loading" : "")}
            onClick={handleSave}
          >
            Guardar
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiPartFieldUpdate;
